import Text from "common/Typography/Text";
import { CSSProperties } from "react";

interface ExtraQuotaTextProps {
  extraQuota?: number;
  textStyle?: CSSProperties;
}

const ExtraQuotaText = ({ extraQuota, textStyle }: ExtraQuotaTextProps) => {
  if (!extraQuota) return null;

  return (
    <Text style={{ display: "inline", marginLeft: 4, ...textStyle }}>
      (+{extraQuota} Additional Quota)
    </Text>
  );
};

export default ExtraQuotaText;
